if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updatePickupAvailability();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        return;
      }

      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();

      // ✅ Fire custom event for other scripts (stock/status sync)
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant,
          sectionId: this.dataset.section
        }
      }));

      // ✅ Immediately sync Add to Cart + Stock status
      const addToCartBtn = document.querySelector(`#product-form-${this.dataset.section} [type="submit"]`);
      const stockStatus = document.querySelector(`#stock-status-${this.dataset.section}`);
      const variant = this.currentVariant;

      if (variant && addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to cart';
          addToCartBtn.classList.remove('is-sold-out');
          if (stockStatus) stockStatus.innerHTML = '<span style="color:green;">In Stock</span>';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold out';
          addToCartBtn.classList.add('is-sold-out');
          if (stockStatus) stockStatus.innerHTML = '<span style="color:red;">Out of Stock</span>';
        }
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), select => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find(variant => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media) return;
      const mediaGallery = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
      if (mediaGallery) mediaGallery.scrollIntoView({ behavior: 'smooth' });
    }

    updateURL() {
      if (this.currentVariant)
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const input = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
      if (input) input.value = this.currentVariant.id;
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

   renderProductInfo() {
  if (!this.currentVariant) return;

  // Grab elements once
  const sectionId = this.dataset.section;
  const addToCartBtn = document.querySelector(`#product-form-${sectionId} [type="submit"]`);
  const stockStatus = document.querySelector(`#stock-status-${sectionId}`);

  // 🔒 Immediately lock the button while fetching
  if (addToCartBtn) {
    addToCartBtn.classList.add('loading');
    addToCartBtn.disabled = true;
    addToCartBtn.style.cursor = 'wait';
  }

  // Keep price in sync without breaking stock text
  fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newPrice = doc.getElementById(`price-${sectionId}`);
      const priceContainer = document.getElementById(`price-${sectionId}`);
      if (priceContainer && newPrice) priceContainer.innerHTML = newPrice.innerHTML;

      // ✅ Now apply final state once fetch completes
      if (this.currentVariant.available) {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to cart';
          addToCartBtn.classList.remove('is-sold-out', 'loading');
          addToCartBtn.style.cursor = 'pointer';
        }
        if (stockStatus) stockStatus.innerHTML = '<span style="color:green;">In Stock</span>';
      } else {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold out';
          addToCartBtn.classList.add('is-sold-out');
          addToCartBtn.classList.remove('loading');
          addToCartBtn.style.cursor = 'not-allowed';
        }
        if (stockStatus) stockStatus.innerHTML = '<span style="color:red;">Out of Stock</span>';
      }
    })
    .catch(err => console.error(err))
    .finally(() => {
      if (addToCartBtn) addToCartBtn.classList.remove('loading');
    });
}


    toggleAddButton(disable = true, text = '', modifyClass = true) {
      const addButton = document.querySelector(`#product-form-${this.dataset.section} [name="add"]`);
      if (!addButton) return;
      addButton.disabled = disable;
      if (text) addButton.textContent = text;
      if (modifyClass) addButton.classList.toggle('disabled', disable);
    }

    setUnavailable() {
      const priceContainer = document.getElementById(`price-${this.dataset.section}`);
      if (priceContainer) priceContainer.textContent = window.variantStrings.unavailable;
    }

    removeErrorMessage() {
      const errorMessage = document.querySelector('.product-form__error-message-wrapper');
      if (errorMessage) errorMessage.innerHTML = '';
    }

    getVariantData() {
      if (!this.variantData)
        this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  });
}
